/**
 * Determines if Tyro payment provider is enabled for the current page
 * @param countryCode - The country code from the page context
 * @returns true if Tyro payment provider is enabled and country is AU, false otherwise
 */
export const isTyro = (countryCode?: string): boolean => {
  return (
    process.env.NEXT_PUBLIC_PAYMENT_PROVIDER === 'tyro' &&
    countryCode === 'AU'
  )
}

